const libPictView = require('pict-view');

class BridgeJumbotron extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('./../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;
	}

	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.log.info(`Jumbotron onBeforeRenderAsync`);
				if (this.pict.AppData.Module)
				{
					this.pict.AppData.ProgramName = `${this.pict.AppData.Module.ProgramName}`;
					this.pict.AppData.BridgeSplashJumbotronLogo = `${this.pict.AppData.Module.ProgramLogoURL}`;
				}
				else if (this.pict.PictApplication.loggedIn)
				{
					//FIXME: we need to wait for the signal from the application that we are authenticated before we can make this request
					const moduleData = await this.pict.providers.ModulesProvider.getModuleByHash('LIMS_MANAGEMENT');
					if (!moduleData)
					{
						this.pict.log.error(`Unable to get module data for LIMS_MANAGEMENT`);
						return fCallback();
					}
					this.pict.AppData.ProgramName = `${moduleData.ProgramName}`;
					this.pict.AppData.BridgeSplashJumbotronLogo = `${moduleData.ProgramLogoURL}`;
				}
			}
			catch (error)
			{
				this.pict.log.error(`Error in Jumbotron onBeforeRenderAsync: ${error.message}`);
			}
			fCallback();
		}, pRenderable);
	}
}

module.exports = BridgeJumbotron;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'Jumbotron',
		DefaultRenderable: 'Jumbotron',
		DefaultDestinationAddress: 'body',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'Jumbotron-Wrapper',
				Template: /*html*/`
				<div id="Jumbotron">
				   <section class="has-background-primary-soft has-text-link-20 hero is-link-85 hero-container">
					<div class="hero-body px-6 py-5">
						<div class="columns">
						   <div class="column is-narrow">
								<img style="max-height: 75px" src="{~D:Pict.AppData.BridgeSplashJumbotronLogo~}"/>
							</div>
							<div class="column">
								<p class="has-text-primary is-size-2 title">HeadLight LIMS</p>
								<p class="has-text-primary is-size-4 subtitle">{~D:Pict.AppData.ProgramName~}</p>
							</div>
						</div>
					</div>
				</section>
				</div>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'Jumbotron',
				TemplateHash: 'Jumbotron-Wrapper',
				RenderMethod: 'prepend',
			} ],
	});
